import { Avatar, Float, Image } from '@chakra-ui/react'

type Props = {
	image: string
	baseUrl?: string
}

export const Picture = ({ image, baseUrl }: Props) => {
	const defaultBaseUrl = baseUrl || `${process.env.REACT_APP_PAYMENT_FORM_URL}l/`
	return (
		<Avatar.Root size={'3xl'}>
			<Avatar.Image src={image} />
			<Avatar.Fallback />
			<Float placement='bottom-end' offsetX='3' offsetY='3'>
				<Image src={`${defaultBaseUrl}assets/img/logo_app_lydia.png`} boxSize='24px' />
			</Float>
		</Avatar.Root>
	)
}
